{
  "title": "Hộp thư đến",
  "totalBadge": "{{count}} mục",
  "viewAll": "Xem tất cả",
  "loading": "Đang tải…",
  "emptySection": "Đã xử lý tất cả",
  "loadError": "Không thể tải mục này"
}
